/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Split_MultiviewInputs */



/**
* | output |
* | --- |
* | "Split Multiview Group" |
*
* @param {Event_Group_Options_Split_MultiviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_split_multiview = /** @type {((inputs?: Event_Group_Options_Split_MultiviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Split_MultiviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe multivue fractionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split Multiview Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dividi il gruppo Multivista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделение группы с несколькими окнами просмотра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo multivista dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拆分多视图组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割マルチビューグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्प्लिट मल्टीव्यू ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de visualização múltipla dividido")
	return /** @type {LocalizedString} */ ("Split Multiview Group")
});